import styled from 'styled-components';
import { PublicPageLayout } from '../components/PublicPageLayout';

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: ${({ theme }) => theme.spacing.lg};
`;

const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  padding: ${({ theme }) => theme.spacing.xl};
`;

const FeatureTitle = styled.h3`
  font-size: ${({ theme }) => theme.fontSize.lg};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

const FeatureBody = styled.p`
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.colors.textSecondary};
  line-height: 1.6;
`;

const features = [
  {
    title: 'AI generation',
    body: 'Text and images generated with OpenAI GPT-4o and KIE.ai models (z-image, Flux). Posts come out with copy, image, and a composition ready to publish.',
  },
  {
    title: '11 social networks',
    body: 'Instagram, Facebook, X/Twitter, LinkedIn, TikTok, Threads, Google Business Profile, Bluesky, YouTube, Pinterest, and Telegram — format and tone adapted to each one.',
  },
  {
    title: 'Brand-aware from the first post',
    body: 'Enter your site URL and Coopen extracts palette, tone, and value proposition. Every piece comes out in your brand language and style.',
  },
  {
    title: 'Template editor',
    body: 'Dynamic templates with text auto-shrink, automatic logo support, gradients, shadows, and shapes. Design once, reuse for hundreds of posts.',
  },
  {
    title: 'Image libraries',
    body: 'Stock photos (Unsplash + Pexels), AI generation, and your own assets — all combinable with templates in one click.',
  },
  {
    title: 'Export ready to schedule',
    body: 'Export CSV+ZIP or push directly to your scheduling tool (GoHighLevel and compatible). No manual copy/paste work.',
  },
  {
    title: 'Workspaces per brand',
    body: 'An agency with several brands runs everything in one place. Each workspace keeps its own brand, library, and templates.',
  },
  {
    title: 'Novah, your copilot',
    body: 'Embedded assistant that suggests improvements, reviews creatives with vision, and answers questions without pulling you out of the flow.',
  },
];

export function FeaturesPage() {
  return (
    <PublicPageLayout
      title="Features"
      subtitle="Everything Coopen SMM does for you so you can produce content at scale — without losing brand identity."
    >
      <Grid>
        {features.map((f) => (
          <Card key={f.title}>
            <FeatureTitle>{f.title}</FeatureTitle>
            <FeatureBody>{f.body}</FeatureBody>
          </Card>
        ))}
      </Grid>
    </PublicPageLayout>
  );
}
